import { useBrand } from '@contexts/useBrand'
import React from 'react'

import { RadioButton } from '../baseInputs'

type Props = {
  label: string
  firstLabel: string
  secondLabel: string
  firstValue: string
  secondValue: string
  name: string
  labelStyle?: string
  containerStyle?: string
  optional?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}

const CustomRadio = ({
  label,
  firstLabel,
  firstValue,
  secondLabel,
  secondValue,
  name,
  optional,
  onChange,
}: Props) => {
  const brand = useBrand()
  return brand === 'kinto' ? (
    <div>
      <label htmlFor={name} className="block">
        <span className={`inline-block text-base-text mb-1`}>{label}</span>
      </label>
      <div
        className={`radio-btn-container flex text-base-text mb-3 min-h-[48px]`}
      >
        <RadioButton
          name={name}
          label={firstLabel}
          value={firstValue}
          errorDisabled
          {...(onChange && { onChange })}
        />
        <RadioButton
          name={name}
          label={secondLabel}
          value={secondValue}
          errorDisabled
          {...(onChange && { onChange })}
        />
      </div>
    </div>
  ) : (
    <div>
      <p className="font-medium my-5">
        {label}
        {optional && (
          <span className="text-xs font-normal lowercase whitespace-nowrap">
            (optional)
          </span>
        )}
      </p>
      <div className="radio-btn-container flex mb-5">
        <RadioButton
          name={name}
          label={firstLabel}
          value={firstValue}
          errorDisabled
          {...(onChange && { onChange })}
        />
        <RadioButton
          name={name}
          label={secondLabel}
          value={secondValue}
          errorDisabled
          {...(onChange && { onChange })}
        />
      </div>
    </div>
  )
}

export default CustomRadio
